import 'core-js/features/array/at'; // Only needed for prerender chromium 89
import 'core-js/features/object/has-own'; // Only needed for prerender chromium 89

import { Buffer } from 'buffer';

import './bigint.ts';

globalThis.Buffer ??= Buffer; // For coinbase-wallet-sdk

Array.prototype.includesValue = function includesValue<T extends U, U>(
  this: T[],
  value: U
): value is T {
  return this.includes(value as T);
};
